export default __webpack_public_path__ + "static/media/Artboard 21.87f4cf9e.png";